import log from 'lib/log'
import {
  LOAD_REQUEST,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  CLEAR_EMBEDS
} from '../actions/embeds'

const posts = (state = {}, action = {}) => {
  switch (action.type) {
    case LOAD_REQUEST:
      if (action.payload && action.payload.opts && action.payload.opts._id) {
        let old = state[action.payload.opts._id]
        state = Object.assign({}, state, {
          [action.payload.opts._id]: {
            loading: true,
            value: old && old.value
          }
        })
      } else {
        log.warn('missing _id parameter in request for embed', action)
      }
      break
    case LOAD_SUCCESS:
      state = Object.assign({}, state, {
        [action.payload.opts._id]: {
          loading: false,
          value: action.payload.result
        }
      })
      break
    case LOAD_FAILURE:
      state = Object.assign({}, state, {
        [action.payload.opts._id]: {
          loading: false,
          error: convertError(action.payload.error)
        }
      })
      break
    case CLEAR_EMBEDS:
      state = {}
      break
  }
  return state
}

export default posts
